
import * as ipxRuntime$6GrRT9XxeM from '/var/www/share/mysofabed.de/app/node_modules/.pnpm/@nuxt+image@1.8.0_db0@0.3.2_ioredis@5.6.1_magicast@0.3.5/node_modules/@nuxt/image/dist/runtime/providers/ipx'

export const imageOptions = {
  "screens": {
    "xs": 320,
    "sm": 640,
    "md": 768,
    "lg": 1024,
    "xl": 1280,
    "xxl": 1536,
    "2xl": 1536
  },
  "presets": {
    "listing": {
      "modifiers": {
        "height": 227,
        "fit": "fill",
        "format": "webp"
      }
    }
  },
  "provider": "ipx",
  "domains": [
    "sw6.mysofabed.de"
  ],
  "alias": {},
  "densities": [
    1,
    2
  ],
  "format": [
    "webp"
  ],
  "quality": 80
}

imageOptions.providers = {
  ['ipx']: { provider: ipxRuntime$6GrRT9XxeM, defaults: {} }
}
        